module.exports = __webpack_public_path__ + "static/media/login_icon.e9df86d2.png";